module.exports = __webpack_public_path__ + "img/git.4da031d6.svg";